import React from 'react';

const getLable = (lable, t) => {
  let result = '';
  switch (lable) {
    case 'walking':
      result = `${t('walking')}`;
      break;
    case 'standing':
      result = `${t('standing')}`;
      break;
    case 'sitting':
      result = `${t('sitting')}`;
      break;
    case 'lying':
      result = `${t('lying')}`;
      break;
    default:
      break;
  }
  return result;
};

const ActivityLegend = ({ data, colorset, total, t }) => (
  <div className="flex flex-col max-w-xs space-y-3">
    {data.map((element, i) => {
      const { label, text } = element;

      const isValidLabel =
        colorset.hasOwnProperty(label) &&
        label !== 'total' &&
        label !== 'mock' &&
        label !== 'target';

      if (!isValidLabel) return null;

      return (
        <div className="flex flex-row my-auto" key={i}>
          <svg width={30} height={30}>
            <circle cx="50%" cy="50%" r="10" fill={colorset[label]} />
          </svg>
          <div className="block w-20 my-auto">
            <span className="text-lg text-summary-header">{getLable(label, t)}</span>
          </div>
          <div className="w-20 my-auto ml-4">
            <span
              className={`text-lg text-right ${
                total
                  ? 'text-summary-header font-semibold'
                  : 'text-chart-target'
              }`}
            >
              {text}
            </span>
          </div>
        </div>
      );
    })}
  </div>
);


export default ActivityLegend;
